export default {
      id: "arrow-top-usage",
      viewBox: "0 0 16 22",
      url: __webpack_public_path__ + "img/icons.svg#arrow-top",
      toString: function () {
        return this.url;
      }
    }